import { supabase } from "@/lib/supabase";

export const validateCoupon = async (code) => {
    // Call the PostgreSQL function we defined in the migration
    const { data, error } = await supabase.rpc('validate_coupon', {
        coupon_code: code
    });

    if (error) {
        console.error("Coupon validation error:", error);
        throw new Error("Unable to validate coupon. Please try again.");
    }

    // The rpc function returns { valid: false, message: ... } on failure
    if (!data || !data.valid) {
        throw new Error(data?.message || "Invalid or expired coupon code");
    }

    // Returns { valid: true, type: 'percent', value: 100, ... }
    return data;
};
